window.PD_ORCHESTRATOR = {};

(function () {
  let giftSelectorExists = !!document.querySelector('.pd-gift-selector');
  let upsellExists = !!document.querySelector('.pd-cart-upsell-popup');

  window.PD_ORCHESTRATOR.limitReached = false;
  window.PD_ORCHESTRATOR.giftClosed = false;

  document.addEventListener('pd:gift-limit-reached', () => {
    window.PD_ORCHESTRATOR.limitReached = true;
  });

  document.addEventListener('pd:gift-closed', () => {
    window.PD_ORCHESTRATOR.giftClosed = true;

    if (upsellExists) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('pd:start-upsell'));
      }, 3000); 
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (!giftSelectorExists) {
      if (upsellExists) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('pd:start-upsell'));
        }, 3000);
      }
      return;
    }

    if (giftSelectorExists && !window.PD_ORCHESTRATOR.limitReached) {
      if (upsellExists) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('pd:start-upsell'));
        }, 3000);
      }
    }
  });
})();